<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap>
      <v-flex
        xs12
        md10>
        <v-flex
          xs12
          pa-0>
          <terms-card type="customer"/>
        </v-flex>
      </v-flex>

      <v-flex
        xs12
        md2>
        <v-card class="pa-3">
          <v-card-text class="align-center">
            <v-switch
              :label="$t('Require ToS acceptance')"
              outline
            />
          </v-card-text>

          <v-card-actions>
            <v-btn
              block
              color="primary"
            >
              {{ $t('Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TermsCard from '@/modules/Auth/components/ToS/TermsCard'
export default {
  name: 'ToS',
  components: { TermsCard }
}
</script>
